var map = {
	"./aichav4_chat_icon1@3x.png": 8314,
	"./aichav4_chat_icon2@3x.png": 2010,
	"./aichav4_topbar_icon1@3x.png": 414,
	"./aichav4_topbar_icon2@3x.png": 7532,
	"./copy.svg": 7918,
	"./duigou.svg": 1338,
	"./failed@3x.png": 9120,
	"./loading.gif": 8064,
	"./loading_re": 8192,
	"./loading_re.json": 8192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;